<h1 mat-dialog-title>Preguntas laboratorio</h1>

<div class="observation-table-scroll">

    <mat-spinner *ngIf="loading"></mat-spinner>

    <ng-container *ngIf="!loading">

        <div *ngFor="let group of groupedQuestions" class="practice-group">

            <!-- Titulo de práctica -->
            <label>
                {{ group.practice }}
            </label>

            <table mat-table [dataSource]="group.questions" class="full-width-table">

                <!-- Columna Pregunta -->
                <ng-container matColumnDef="question">
                    <th mat-header-cell *matHeaderCellDef> Pregunta </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.Question }}
                    </td>
                </ng-container>

                <!-- Columna Respuesta -->
                <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef> Respuesta </th>
                    <td mat-cell *matCellDef="let element">

                        <mat-checkbox [(ngModel)]="element.Value">
                        </mat-checkbox>

                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['question','value']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['question','value'];"></tr>

            </table>

        </div>

    </ng-container>

</div>

<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        <button mat-button type="button" cdkFocusInitial (click)="save()">Aceptar</button>
    </div>
</div>